import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import cn from 'classnames';
import {useLocalizer} from '@/common/services/localizer';
import {minutesToTimeString} from '@/common/helpers/date/minutesToTimeString';
import {LocationSunTime} from '@/common/interfaces/location';
import {selectClockType} from '@/app/store/config/selectors';
import styles from './SunTime.css';

interface SunTimeProps {
	className: string;
	sunTime: LocationSunTime;
	multiline?: boolean;
}

export const SunTime: FC<SunTimeProps> = props => {
	const {className, sunTime, multiline} = props;

	const t = useLocalizer();
	const clockType = useSelector(selectClockType);

	if (sunTime.isPolarDay || sunTime.isPolarNight) {
		return (
			<p className={cn(styles.root, className)}>
				<span className={styles.polar}>
					{sunTime.isPolarDay && t('polarDay')}
					{sunTime.isPolarNight && t('polarNight')}
				</span>
			</p>
		);
	}

	if (!sunTime.sunrise || !sunTime.sunset) {
		return null;
	}

	const sunrise = minutesToTimeString(sunTime.sunrise, clockType);
	const sunset = minutesToTimeString(sunTime.sunset, clockType);

	return (
		<p className={cn(styles.root, multiline && styles.isMultiline, className)}>
			{t('sunrise')} <span className={styles.value}>{sunrise}</span>
			{' ' /* Separate */}
			{multiline && <br />}
			{t('sunset')} <span className={styles.value}>{sunset}</span>
		</p>
	);
};

SunTime.displayName = 'SunTime';
